import { ROLE_ADMIN_ID } from 'model/Role';

/**
 * Resolves whether the global-permissions section should be visible in the user form.
 */
export function shouldShowGlobalPermissionsSection(currentUserRoleId: number | null, targetUserRoleId: string) {
  return currentUserRoleId === ROLE_ADMIN_ID && targetUserRoleId !== String(ROLE_ADMIN_ID);
}
